import { Link, Meta } from '@/@types/Pagination';

export const SHIPPING_ALL_VALUE = 'ALL' as const;

export const APPLY_TO_ALL_CURRENCIES = 'apply_to_all_currencies' as const;

export type ShippingWildcard = typeof SHIPPING_ALL_VALUE;

export type ShippingNamedItem = {
  id: string;
  name: string;
};

export type ShippingNamedItemApi = {
  id?: string;
  uuid?: string;
  name?: string;
  label?: string;
};

export function shippingNamedItemsToIds(items: ShippingNamedItem[]): string[] {
  return items.map((item) => item.id);
}

export type ShippingConfigurationApi = {
  id: string | number;
  name: string;
  productIds?: Array<string | ShippingNamedItemApi | ShippingWildcard>;
  products?: Array<string | ShippingNamedItemApi | ShippingWildcard>;
  offers: Array<string | ShippingNamedItemApi | ShippingWildcard>;
  offerIds?: Array<string | ShippingNamedItemApi | ShippingWildcard>;
  currencies: string[] | ShippingWildcard[];
  countries: string[] | ShippingWildcard[];
  min_quantity?: number;
  minQuantity?: number;
  amount: number;
  amount_formatted?: string;
  currency?: string;
  status: boolean;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;
};

export type ShippingConfiguration = {
  id: string;
  name: string;
  products: ShippingNamedItem[];
  offers: ShippingNamedItem[];
  currencies: string[];
  countries: Array<string | ShippingWildcard>;
  minQuantity: number;
  amount: number;
  amountFormatted: string;
  amountCurrency: string;
  status: boolean;
};

export type ShippingConfigurationPayload = {
  name: string;
  products: string[];
  offers: string[];
  currencies: string[];
  countries: Array<string | ShippingWildcard>;
  minQuantity: number;
  amount: number;
  amountCurrency: string;
  status: boolean;
};

export type ShippingConfigurationListParams = {
  page?: number;
  limit?: number;
  offerId?: string;
  currency?: string;
  countryId?: number;
  status?: boolean;
};

export type ShippingConfigurationsListResponse = {
  data: ShippingConfiguration[];
  meta?: Meta;
  links?: Link;
};

export type ShippingAuxOption = {
  value: string;
  label: string;
};

export type ShippingOfferApi = {
  id: string;
  name: string;
};

export type ShippingCurrencyApi = {
  code: string;
  name?: string;
};

export type CheckoutShippingParams = {
  offerId: string;
  currency: string;
  countryId: number;
  quantity: number;
};

export type CheckoutShippingResponse = {
  available: boolean;
  amount?: number;
  reason?: string;
  configuration_id?: number;
};
